import { useContext } from "react";

import type { Feed } from "@/db/types";
import { AppContext } from "@/models/AppStateProvider";
import type { FullItem } from "@/models/FeedContextProvider";
import ClassicFeedItem from "./classic/ClassicFeedItem";
import DriverCentricFeedItem from "./driver-centric/DriverCentricFeedItem";

type Props = {
  item: FullItem;
  feed: Feed;
  vListIndex?: number;
  active?: boolean;
  highlightPodcast: boolean;
  setItemNotLoaded?: (value: string) => void;
  preventScroll?: (value: boolean) => void;
  aliasChannelOwnerId?: string;
};

export default function FeedItem(props: Props) {
  const { flags } = useContext(AppContext);
  return flags.newDesign ? <DriverCentricFeedItem {...props} /> : <ClassicFeedItem {...props} />;
}
